import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  dialogContent: {
    padding: "20px 10px"
  },
  message: {
    fontWeight: "bold",
    fontSize: "20px",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px"
    }
  },
  description: {
    color: theme.palette.text.secondary
  },
  dialogActions: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  checkbox: {
    margin: 0
  },
  buttonsRow: {
    display: "flex",
    gap: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      justifyContent: "flex-end"
    }
  },
  button: {
    minWidth: "7rem",
    height: "2.5rem",
    padding: "8px 20px"
  }
}));

export default useStyles;
